export default __webpack_public_path__ + "static/media/progress-hd.4eb1b738.png";